import React from "react";
import styled from "styled-components";
import Skeleton from "react-loading-skeleton";
const Wrapper = styled.div`
  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.1), 0px 1px 2px rgba(0, 0, 0, 0.06);
  border-radius: 12px;
  height: 50%;
  .border-CK {
    border-bottom: 1px solid #e5e7eb;
  }
  .color-CK {
    color: #374151;
  }
`;
const IncomeCard = ({ datas, loaded }) => {
  return (
    <Wrapper className="w-full">
      <div className="flex flex-col p-6">
        <h4 className="pb-2 border-CK color-CK text-sm font-bold">Орлого</h4>
        {loaded ? (
          <h5 className="py-3 font-bold text-3xl">{datas.income}₮</h5>
        ) : (
          <div className="w-full h-full text-center py-4">
            <Skeleton count={1} height={30} />
          </div>
        )}

        <h4 className="text-xs font-semibold color-grey">
          Сонгосон хугацаан дах
        </h4>
      </div>
    </Wrapper>
  );
};

export default IncomeCard;
